<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button v-if="orderStatus===1" content="button.approve" icon="vxe-icon-check" mode="text" status="success" @click="submit('approve')"/>
        <vxe-button v-if="orderStatus===1" content="button.reject" icon="vxe-icon-undo" mode="text" status="error" @click="submit('reject')"/>
        <vxe-button v-if="orderStatus===3" content="button.submit" icon="vxe-icon-signature" mode="text" status="success" @click="submit('report')"/>
        <vxe-button v-if="orderStatus===43" content="button.approve" icon="vxe-icon-check" mode="text" status="success" @click="submit('destroy')"/>
      </template>
      <vxe-form ref="order" :data="order" :rules="rules" border size="medium" span="8" title-align="center" title-background title-bold>
        <vxe-form-item field="no" title="business.label.orderNo"/>
        <vxe-form-item field="invoiceTime" title="business.label.invoiceTime"/>
        <vxe-form-item field="owner.name" title="business.label.owner"/>
        <vxe-form-item :field="[fields[type]].operator" :title="$t('business.label.'+[fields[type]]+'Operator')">
          <template #default>
            <vxe-input v-model="order[fields[type]].operator" :editable="false" style="width: 100%" @clear="onOperatorChange([])" @click="onOperatorSelect"/>
            <UserModal ref="userModal" @change="onOperatorChange"/>
          </template>
        </vxe-form-item>
        <vxe-form-item :field="[fields[type]].content" :title="$t('business.label.'+[fields[type]]+'Content')" span="16">
          <template #default>
            <vxe-input v-model="order[fields[type]].content" style="width: 100%"/>
          </template>
        </vxe-form-item>
      </vxe-form>
    </vxe-card>
    <vxe-table ref="table" :data="details" :loading="loading">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="150"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo" width="120"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="location.no" title="business.label.locationNo" width="120"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="detail.inventoryState" title="business.label.inventoryState" width="100"/>
      <vxe-column field="detail.quantity" title="title.unqualifiedQuantity" width="100"/>
      <vxe-column field="detail.reasons" title="business.label.reason"/>
    </vxe-table>
  </div>
</template>

<script>
import { findAll, findOne, post } from '@/api/Api'
import { DisqualificationOrder } from '@/api/dto/order/DisqualificationOrder'
import UserModal from '@/views/modal/UserModal.vue'
import api from '@/api'
import { getEnums, getUser } from '@/utils/util'

export default {
  name: 'DisqualificationDetail',
  components: { UserModal },
  props: {
    orderStatus: { type: Number, default: null },
    type: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      operator: getUser(),
      order: new DisqualificationOrder(),
      details: [],
      inventoryStates: [],
      rules: {
        approver: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        applier: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        confirmer: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      },
      urls: {
        approve: api.conversionQualifierApprove,
        reject: api.conversionQualifierReject,
        report: api.conversionQualifierReport,
        destroy: api.conversionQualifierDestroy
      },
      fields: {
        approve: 'approvalAdvice',
        report: 'reportAdvice',
        destroy: 'destructionAdvice'
      }
    }
  },
  created() {
    getEnums('InventoryState').then(result => {
      this.inventoryStates = result
    })
  },
  methods: {
    back() {
      this.$emit('back')
    },
    onOperatorSelect() {
      this.$refs.userModal.open({ available: true })
    },
    onOperatorChange(values) {
      this.order[this.fields[this.type]].operator = values[0]?.name
    },
    edit(row) {
      this.loading = true
      findOne('disqualificationOrderFactory', { id: row.order.id }).then(res => {
        if (res.success) {
          this.order = new DisqualificationOrder(res.result)
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('disqualificationDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.details = res.result
        }
      }).finally(() => this.loading = false)
    },
    submit(type) {
      this.loading = true
      if (!this.order[this.fields[this.type]].operator) this.order[this.fields[this.type]].operator = this.operator.name
      post(this.urls[type], {}, this.order.toJSONObject()).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.back()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>